import fetch from '@dp/varyag-hoc-component/fetch';
import { isArray } from "../lib/util";

const createFetch = fetch.create({
    host: {
        dev: '/api',
    }
});

export default async (shopId) => {
    let shopInfo = {};
    try {
        const result = await createFetch({
            credentials: 'include',
            url: `/union/shop/info`,
            data: {
                dpShopIds: shopId,
            }
        });
        if (isArray(result) && result[0]) {
            shopInfo = {
                ...result[0]
            }
        }
    } catch (e) {
        console.error(e);
    }
    return shopInfo;
}



// WEBPACK FOOTER //
// ./src/api/getShopInfo.js